var TIME_DIFF_MS = 50 * 60 * 1000; // 5 minutes
var SessionToken = /** @class */ (function () {
    function SessionToken(props) {
        this.token = props.token;
        this.type = props.type;
        this.expirationTime = props.expirationTime;
        this.sessionId = props.sessionId;
    }
    SessionToken.isExpired = function (token) {
        var expirationTime = token.expirationTime;
        return (new Date(expirationTime).getTime() - new Date().getTime() <= TIME_DIFF_MS);
    };
    return SessionToken;
}());
export { SessionToken };
